import Container from "@client/content/Containers/container";
import InstagramFeed from "@client/content/controls/Instragram/Feed/component";
import { type InstagramFeedOptions } from "@client/content/controls/Instragram/Feed/lib";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";

export type InstagramComponentProps = RootContainerProps & {
  columns: number;
  columnWidth: string;
  feedOptions: InstagramFeedOptions;
  itemGap: string;
  itemStyle: React.CSSProperties;
};

export default (props: InstagramComponentProps) => (
  <Container {...getContainerProps(props)}>
    <InstagramFeed
      columns={props.columns}
      columnWidth={props.columnWidth}
      feedOptions={props.feedOptions}
      itemGap={props.itemGap}
      itemStyle={props.itemStyle}
    />
  </Container>
);
